import React, { FunctionComponent, useEffect } from "react";

import * as H from "history";
import { useDispatch } from "react-redux";
import { Router, Switch, Route } from "react-router-dom";

import { clearBreadcrumbs } from "../../features/breadcrumbs/breadcrumbsSlice";
import { ActionSuffixes, Prefixes } from "../prefixes";
import { KnowledgeBases } from './index';
import { NewKnowledgeBase } from './new';
import { EditKnowledgeBase } from './edit';

interface AdminRouterProps {
  history: H.History<any>;
}

const prefix = Prefixes.knowledgeBase;

export const KnowledgeBasesRouter: FunctionComponent<AdminRouterProps> = ({
  history,
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    return history.listen((location) => {
      dispatch(clearBreadcrumbs());
    });
  }, [dispatch, history]);
  return <Router history={history}>
    <Switch>
      <Route path={`${prefix}${ActionSuffixes.new}`} exact>
        <NewKnowledgeBase />
      </Route>
      <Route path={`${prefix}/:id${ActionSuffixes.edit}`} exact>
        <EditKnowledgeBase />
      </Route>
      <Route path={prefix}>
        <KnowledgeBases />
      </Route>
    </Switch>
  </Router>;
};